import { basicPath } from '../basicPath';

// Helper function to get the correct API path prefix based on domain
const getAppointmentsPath = (endpoint) => {
    const hostname = window.location.hostname;
    const prefix = hostname.includes('readingplex') ? '/rp' : '/mp';
    return `${prefix}/appointments/${endpoint}`;
};

export const fetchAppointmentsDateCenter = (params) => async (dispatch) => {
    const path = getAppointmentsPath('date-center');
    const type = 'get';
    return await basicPath(dispatch, params, path, type);
}

export const fetchAppointmentsDateOnly = (params) => async (dispatch) => {
    const path = getAppointmentsPath('date-only');
    const type = 'get';
    return await basicPath(dispatch, params, path, type);
}

export const fetchAppointmentsDaterange = (params) => async (dispatch) => {
    const path = getAppointmentsPath('daterange-only');
    const type = 'get';
    return await basicPath(dispatch, params, path, type);
}

export const fetchAppointmentsDaterangeStudent = (params) => async (dispatch) => {
    const path = getAppointmentsPath('daterange-student');
    const type = 'get';
    return await basicPath(dispatch, params, path, type);
}

export const fetchAppointmentsDaterangeCenterStudentName = (params) => async (dispatch) => {
    const path = getAppointmentsPath('daterange-center-student-name');
    const type = 'get';
    return await basicPath(dispatch, params, path, type);
}

export const fetchAppointmentsIds = (params) => async (dispatch) => {
    const path = getAppointmentsPath('ids');
    const type = 'get';
    return await basicPath(dispatch, params, path, type);
}

export const createAppointment = (params) => async (dispatch) => {
    const path = getAppointmentsPath('single');
    const type = 'post';
    return await basicPath(dispatch, params, path, type);
}

export const createAppointmentsBulk = (params) => async (dispatch) => {
    const path = getAppointmentsPath('bulk');
    const type = 'post';
    return await basicPath(dispatch, params, path, type);
}

export const updateAppointmentCore = (params) => async (dispatch) => {
    const path = getAppointmentsPath('core');
    const type = 'put';
    return await basicPath(dispatch, params, path, type);
}

export const updateAppointmentStatus = (params) => async (dispatch) => {
    const path = getAppointmentsPath('status');
    const type = 'put';
    return await basicPath(dispatch, params, path, type);
}

export const updateAppointmentDetails = (params) => async (dispatch) => {
    const path = getAppointmentsPath('details');
    const type = 'put';
    return await basicPath(dispatch, params, path, type);
}

export const updateAppointmentInstructors = (params) => async (dispatch) => {
    const path = getAppointmentsPath('instructors');
    const type = 'put';
    return await basicPath(dispatch, params, path, type);
}

export const updateAppointmentStampsGiven = (params) => async (dispatch) => {
    const path = getAppointmentsPath('stamps-given');
    const type = 'put';
    return await basicPath(dispatch, params, path, type);
}

export const deleteAppointment = (params) => async (dispatch) => {
    const path = getAppointmentsPath('standard');
    const type = 'delete';
    return await basicPath(dispatch, params, path, type);
}

export const deleteAppointmentForce = (params) => async (dispatch) => {
    const path = getAppointmentsPath('force');
    const type = 'delete';
    return await basicPath(dispatch, params, path, type);
}

// Member portal endpoints
export const fetchMemberAppointmentsParentStudent = (params) => async (dispatch) => {
    const hostname = window.location.hostname;
    const path = hostname.includes('readingplex')
        ? '/rp/member/appointments/parent-student'
        : '/mp/member/appointments/parent-student';
    const type = 'get';
    // For GET requests, we need to pass params as query string, not in body
    return await basicPath(dispatch, params, path, type);
}

// Unified member portal - fetch appointments from both MathPlex and ReadingPlex
export const fetchMemberAppointmentsUnified = (params) => async (dispatch) => {
    const results = {
        mathplex: [],
        readingplex: []
    };

    try {
        // Fetch MathPlex appointments
        const mpPath = '/mp/member/appointments/parent-student';
        const mpRes = await basicPath(dispatch, params, mpPath, 'get');
        if (mpRes && mpRes.status === 200 && Array.isArray(mpRes.data)) {
            // Filter to only MathPlex appointments (should have n_pages, n_lessons, stamps_given)
            results.mathplex = mpRes.data.filter(apt =>
                apt.n_pages || apt.n_lessons || apt.stamps_given
            );
        }
    } catch (err) {
        console.log('[UNIFIED] MathPlex appointments fetch failed:', err);
    }

    try {
        // Fetch ReadingPlex appointments
        const rpPath = '/rp/member/appointments/parent-student';
        const rpRes = await basicPath(dispatch, params, rpPath, 'get');
        if (rpRes && rpRes.status === 200 && Array.isArray(rpRes.data)) {
            // Filter to only ReadingPlex appointments (should have homework_notes, participation, etc.)
            results.readingplex = rpRes.data.filter(apt =>
                apt.homework_notes || apt.participation || apt.answer_accuracy || apt.depth_of_thinking
            );
        }
    } catch (err) {
        console.log('[UNIFIED] ReadingPlex appointments fetch failed:', err);
    }

    return {
        status: 200,
        data: results
    };
}

